module.exports = __webpack_public_path__ + "img/34.a91abe0c.png";